import { QUERY_CLIENT } from '@constants/react-query';

import { SESSION_EVENT_CHANNEL, SESSION_OBJECT_PREFIX, USER_SESSION_URL } from '../constants';
import { deleteLocalRefreshToken } from './refresh-token';
import { deleteLocalAuthenticationToken } from './token';

const clearSessionObjects = (): void => {
  QUERY_CLIENT.cancelQueries();

  QUERY_CLIENT.removeQueries({
    predicate: ({ queryKey }) => {
      if (Array.isArray(queryKey)) {
        const keyItem = queryKey.find((keyPart) => {
          if (typeof keyPart === 'string') {
            return keyPart.startsWith(SESSION_OBJECT_PREFIX);
          }
          return false;
        });
        return Boolean(keyItem);
      }
      if (typeof queryKey === 'string') {
        return queryKey.startsWith(SESSION_OBJECT_PREFIX);
      }
      return false;
    },
  });

  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith(SESSION_OBJECT_PREFIX)) {
      localStorage.removeItem(key);
    }
  });

  SESSION_EVENT_CHANNEL.emitSessionObjectsCleared();
};

export const logout = (): void => {
  deleteLocalAuthenticationToken();
  deleteLocalRefreshToken();
  SESSION_EVENT_CHANNEL.emitTokenRemoved();

  clearSessionObjects();
};

export const saveUserLoginRedirectURL = (locale: string): void => {
  const locationWithoutLocale = window.location.href.replace(`/${locale}`, '');
  localStorage.setItem(USER_SESSION_URL, locationWithoutLocale.replace(window.location.origin, ''));
};
